// ReplyModal.jsx
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ReplyModal = ({ show, handleClose, onSend }) => {
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    if (!message.trim()) return;
    onSend(message);
    setMessage("");
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Post Reply</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Type your reply..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          style={{ background: "#ff6b00", border: "none" }}
        >
          Send Reply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReplyModal;